import { AnonymousAuth, AnonymousAuthTitle } from './Anonymous/Anonymous'
import { Register, RegisterTitle } from './Register/Register'
import { SignIn, SignInTitle } from './SignIn/SignIn'

const AuthGateway = {
    SignIn: {
        Title: SignInTitle,
        View: SignIn,
    },
    Register: {
        Title: RegisterTitle,
        View: Register,
    },
    Anonymous: {
        Title: AnonymousAuthTitle,
        View: AnonymousAuth,
    },
}

export default AuthGateway
